import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveCompany, GetCompany, saveCompanyAll } from './index';

// Api's
import { companyApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getCompanySaga(action: GetCompany) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      companyApi.getDomain,
      action.payload.request
    );
    if (response.data.result) {
      yield put(
        saveCompany(
          response.data.result,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveCompany(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}
export function* getCompanyAllSaga(action: GetCompany) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      companyApi.getDomainAll,
      action.payload.request
    );
    if (response.data.result) {
      yield put(
        saveCompanyAll(
          response.data.result,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveCompanyAll(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}

